import {
  createPanelFrame,
  resolveTitle,
  createMetric,
  formatNumber,
  formatDuration
} from './panel-utils.js';

const DEFAULT_TASKS = [
  { id: 'ingest', name: 'Ingest', status: 'success', stage: 'Extract', duration: 42 },
  { id: 'clean', name: 'Cleanse', status: 'success', stage: 'Transform', duration: 58 },
  { id: 'feature', name: 'Feature Store', status: 'running', stage: 'Transform', duration: 92 },
  { id: 'train', name: 'Train v12', status: 'queued', stage: 'Train', duration: 0 },
  { id: 'deploy', name: 'Deploy', status: 'blocked', stage: 'Serve', duration: 0 }
];

export function render({ node, api }) {
  const { root, body, titleEl, metaEl } = createPanelFrame(node, 'Pipeline Orchestrator');
  const metrics = document.createElement('div');
  metrics.className = 'ew-metric-grid';

  const stagesWrap = document.createElement('div');
  stagesWrap.className = 'ew-stage-grid';

  body.append(metrics, stagesWrap);

  const update = (next) => {
    titleEl.textContent = resolveTitle(next, 'Pipeline Orchestrator');
    const tasks = Array.isArray(next?.data?.tasks || next?.props?.tasks)
      ? (next.data?.tasks || next.props?.tasks)
      : DEFAULT_TASKS;

    const statusCount = (status) => tasks.filter((t) => t.status === status).length;
    metaEl.textContent = `${tasks.length} tasks`;

    metrics.innerHTML = '';
    metrics.append(
      createMetric('running', formatNumber(statusCount('running'))),
      createMetric('failed', formatNumber(statusCount('failed'))),
      createMetric('queued', formatNumber(statusCount('queued')))
    );

    stagesWrap.innerHTML = '';
    const stages = groupStages(tasks);
    stages.forEach((stage) => {
      const stageEl = document.createElement('div');
      stageEl.className = 'ew-stage';
      const title = document.createElement('div');
      title.className = 'ew-stage-title';
      title.textContent = stage.name;
      stageEl.appendChild(title);

      stage.tasks.forEach((task) => {
        const card = document.createElement('button');
        card.type = 'button';
        card.className = `ew-task ew-task-${task.status || 'idle'}`;
        const name = document.createElement('div');
        name.className = 'ew-task-title';
        name.textContent = task.name;
        const meta = document.createElement('div');
        meta.className = 'ew-task-meta';
        meta.textContent = `${task.status} � ${formatDuration(task.duration || 0)}`;
        card.append(name, meta);
        card.addEventListener('click', () => {
          api.emit('node:input', { id: node.id, field: 'task', value: task.id });
        });
        stageEl.appendChild(card);
      });

      stagesWrap.appendChild(stageEl);
    });
  };

  update(node);
  return { el: root, update };
}

function groupStages(tasks) {
  const map = new Map();
  tasks.forEach((task) => {
    const stage = task.stage || 'Stage';
    if (!map.has(stage)) map.set(stage, []);
    map.get(stage).push(task);
  });
  return Array.from(map.entries()).map(([name, list]) => ({ name, tasks: list }));
}
